import {
  CORPORATE_INNSKUDDSFRITAK_COVERAGE_CODE,
  InsuranceOverview,
  isCorporatePayedInsuranceOverview,
  isPrivateInsuranceOverview,
  PrivateInsuranceOverview,
} from 'Api/insurance';
import { Brand } from 'App/themes/themes.types';
import {
  RENEWAL_DOCUMENT,
  RENEWAL_DOCUMENT_AKA,
} from 'Constants/url.constants';
import {
  isAdvantageousCustomer,
  isCollectiveDiscountCustomer,
} from 'Utils/agreementCodes/agreementCodes.utils';
import { isUnderChangeCwp } from 'Utils/insuranceStatus/insuranceStatus.utils';

export const getRenewalDocumentLink = (brand: Brand) => {
  switch (brand) {
    case 'akademikerne':
      return RENEWAL_DOCUMENT_AKA;
    case 'stb':
    case 'coop':
    case 'danskeBank':
    case 'huseierne':
    default:
      return RENEWAL_DOCUMENT;
  }
};
export const filterPrivate = (
  insurances: InsuranceOverview[],
): PrivateInsuranceOverview[] => {
  return insurances.filter(isPrivateInsuranceOverview);
};

export const filterCorporate = (insurances: Array<InsuranceOverview>) => {
  return insurances
    .filter(isCorporatePayedInsuranceOverview)
    .filter(isNotInsuranceWithOnlyContributionExemption);
};

/** Insurances with only a innskuddsfritak coverage should not be shown on mypages */
export const isNotInsuranceWithOnlyContributionExemption = (
  insurance: InsuranceOverview,
) => {
  return !insurance.coverages.every(
    (cov) => cov.code === CORPORATE_INNSKUDDSFRITAK_COVERAGE_CODE,
  );
};

export const hasInsurancesUnderChange = (insuranceData: InsuranceOverview[]) =>
  insuranceData.some((insurance) => isUnderChangeCwp(insurance.status));

export const hasPrivateInsurances = (insuranceData: InsuranceOverview[]) =>
  insuranceData.some((insurance) => isPrivateInsuranceOverview(insurance));

export const hasCorporateInsurances = (insuranceData: InsuranceOverview[]) =>
  insuranceData.some((insurance) =>
    isCorporatePayedInsuranceOverview(insurance),
  ) && insuranceData.some(isNotInsuranceWithOnlyContributionExemption);

const hasAdvantage = (insurances: InsuranceOverview[]) =>
  insurances.some(
    (insurance) =>
      isPrivateInsuranceOverview(insurance) &&
      isAdvantageousCustomer(insurance.agreementProduct),
  );

const hasCollectedDiscount = (insurances: InsuranceOverview[]) =>
  insurances.some(
    (insurance) =>
      isPrivateInsuranceOverview(insurance) &&
      isCollectiveDiscountCustomer(insurance.agreementProduct),
  );

// Returns the Id for Campaign container based on the type of discount available to the customer. Advantage has higher priotiy than collected discount.
export const getSalesCardId = (insurances: InsuranceOverview[]) => {
  if (hasAdvantage(insurances)) {
    return 'salesCard_hasAdvantage';
  }
  if (hasCollectedDiscount(insurances)) {
    return 'salesCard_hasCollectedDiscount';
  }
  return 'salesCard';
};
